import { PanelItem } from '../../../panel-items/panel-item.class';

export const isExcludedCfn = (panelItem: PanelItem): boolean => {
	const { category } = panelItem.item.component;
	return category.isVent || category.isPassthrough || category.key === 'system';
};
